export default "__VITE_ASSET__DVg5p7zz__"